export const messages = {
  en: {
    chainSupplierCatalog: {
      addCatalog: 'Add Catalog',
      editCatalog: 'Edit Catalog',
      catalogName: 'Catalog Name',
      catalogNamePlaceholder: 'Please enter catalog name',
      catalogNameRequired: 'Catalog name is required',
      catalogNameMaxLength: 'Catalog name cannot exceed 30 characters',
      intfUrlParam: 'Interface Parameter',
      intfUrlParamPlaceholder: 'Please enter interface parameter',
      intfUrlParamRequired: 'Interface parameter is required',
      intfUrlParamMaxLength: 'Interface parameter cannot exceed 64 characters',
      seq: 'Sequence',
      seqPlaceholder: 'Please enter sequence',
      seqRequired: 'Sequence is required',
      seqMaxLength: 'Sequence cannot exceed 10 characters',
      confirmDeleteCatalog: 'Are you sure to delete this catalog?',
      supplierIdRequired: 'Supplier ID is required',
      supplierIdMaxLength: 'Supplier ID cannot exceed 32 characters',
      catalogIdRequired: 'Catalog ID is required'
    }
  },
  zh: {
    chainSupplierCatalog: {
      addCatalog: '添加分类',
      editCatalog: '修改分类',
      catalogName: '分类名称',
      catalogNamePlaceholder: '请输入分类名称',
      catalogNameRequired: '分类名称不能为空',
      catalogNameMaxLength: '分类名称不能超过30个字符',
      intfUrlParam: '对端接口参数',
      intfUrlParamPlaceholder: '请输入对端接口参数',
      intfUrlParamRequired: '对端接口参数不能为空',
      intfUrlParamMaxLength: '对端接口参数不能超过64个字符',
      seq: '排序',
      seqPlaceholder: '请输入排序',
      seqRequired: '排序不能为空',
      seqMaxLength: '排序不能超过10个字符',
      confirmDeleteCatalog: '确定删除分类吗？',
      supplierIdRequired: '供应商ID不能为空',
      supplierIdMaxLength: '供应商ID不能超过32个字符',
      catalogIdRequired: '分类ID不能为空'
    }
  }
}